<template>
  <div :class="componentClassName">
    <a-page-heading>ユーザー管理</a-page-heading>

    <m-section v-if="isScreenReady" variant="fullpage">
      <m-action-card title="ユーザー追加" icon="user" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-users-add__form" @submit.prevent="handleFormSubmit">
          <a-text size="small"> ユーザー数の上限は{{ maxUser }}人までです。 </a-text>
          <div class="t-setting-users-add__fields">
            <m-user-invitation-radio
              v-model="userInvitationMode"
              v-model:user-list="userList"
              :add-limit="addLimit"
              name="userInvitation"
              value="list"
              @reach-limit="reachLimit"
            />
            <!--Not use in current phase-->
            <!-- <m-user-invitation-upload-radio
              v-model="userInvitationMode"
              v-model:upload-file="uploadFile"
              name="userInvitation"
              :template-url="templateDownloadUrl"
              value="upload"
            /> -->
          </div>
          <m-form-action-buttons>
            <a-button
              id="saveBtn"
              variant="block"
              color="primary"
              :disabled="!flagSaveButtonEnable"
              @click="handleFormSubmit(e)"
              >保存</a-button
            >
            <a-button id="cancelBtn" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
          </m-form-action-buttons>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingUserAdd_comfirmModal"
      v-model:visible="confirmUserInvitationDialogVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelUserInvitation"
    >
      <template #title> ユーザー追加 </template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <span v-html="addUserInvitationConfirmationMessage" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="cancel"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelUserInvitation"
        />
        <a-button
          id="confirm"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmUserInvitation"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingUserAdd_vdxModal"
      v-model:visible="vdxGroupModalVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :show-close="false"
    >
      <!-- <template #title> ユーザー追加 </template> -->
      <a-text :center="true">
        <span
          >こちらのメールアドレスはVoiceDXで使用されています。オペレータ名は既存の設定が優先されますがよろしいでしょうか？</span
        >
      </a-text>
      <template #footer>
        <a-button
          id="cancel"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="vdxGroupModalVisible = false"
        />
        <a-button
          id="confirm"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="
            vdxGroupModalVisible = false;
            handleUserInvitationAdd();
          "
        />
      </template>
    </o-modal>
  </teleport>

  <!-- Info, Erro Modal -->
  <teleport to="body">
    <o-modal
      id="settingUserAdd_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="confirmResult"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AText from '@/components/atoms/text';
import MUserInvitationRadio from '@/components/molecules/user-invitation-radio';
// import MUserInvitationUploadRadio from '@/components/molecules/user-invitation-upload-radio';
import OModal from '@/components/organisms/modal';

import { utils } from '@/common/utils.js';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { MAX_USER_PER_COMPANY, MAX_USER_COM_COMPANY, MAX_USER_PER_COMPANY_TRIAL } from '@/libs/constants';
import { statusConst } from '@/libs/constants';
import { POINT, PERMISSIONS_FRONTEND } from '@/libs/constants';

export default {
  name: 't-setting-users-add',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AText,
    AButton,
    MUserInvitationRadio,
    // MUserInvitationUploadRadio,
    MFormActionButtons,
    OModal,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      userInvitationMode: 'list',
      userList: [],
      uploadFile: [],
      confirmUserInvitationDialogVisible: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      addUserInvitationConfirmationMessage: '',
      userListUrl: '',
      templateDownloadUrl: '',
      authInfo: this.$store.state.user.authInfo,
      selectedCompanyID: '',
      flagSaveButtonEnable: true, //#1892
      vdxGroupModalVisible: false,
      vdxGroup: false,
      addLimit: 0, // 追加可能のユーザー数
      isTrial: false,
      isScreenReady: false,
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-users-add');
      return `${baseClassName} ${this.class}`.trim();
    },
    maxUser() {
      if (this.isTrial) {
        return MAX_USER_PER_COMPANY_TRIAL;
      } else {
        return this.selectedCompanyID === POINT ? MAX_USER_COM_COMPANY : MAX_USER_PER_COMPANY;
      }
    },
    canAddUser() {
      if (this.companyID === POINT && this.authInfo === 'manager' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID === POINT && this.authInfo === 'operator' && this.selectedCompanyID === POINT) {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'manager') {
        return false;
      } else if (this.companyID !== POINT && this.authInfo === 'operator') {
        return false;
      } else {
        return PERMISSIONS_FRONTEND['userAdd'][this.authInfo];
      }
    },
  },
  created() {
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    this.isTrial = utils.chkTrialCompanyID(this.selectedCompanyID);
    this.calculateUserAddLimit();
  },
  mounted() {
    this.flagSaveButtonEnable = true; //#1892
    const authInfo = this.$route.query.authInfo;

    if (!this.canAddUser) {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    calculateUserAddLimit() {
      this.postRequest('/idmgmt/getuserlist', { companyID: this.selectedCompanyID })
        .then(res => {
          if (!res.data) throw new Error('Fetch user list failed');
          const userCount = Object.keys(res.data).length;
          this.addLimit = this.maxUser - userCount;
          this.isScreenReady = true;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleSaveClick() {
      // get form data
      this.$refs.form.submit();
    },
    async handleFormSubmit() {
      // 変更SO承認待ちのとき、ユーザIDを追加できない
      const soStatusResult = await this.checkSoStatus();
      if (!soStatusResult) {
        return false;
      }

      let check = true;
      if (this.userList.length <= 0) return this.showErrorModal(messageContent.requireAdd('ユーザー'));
      this.userList.forEach(user => {
        if (!user.userID) {
          check = false;
          return this.showErrorModal(messageContent.requireInput('メールアドレス'));
        }
        if (!this.addressCheck(user.userID)) {
          check = false;
          return this.showErrorModal(messageContent.alertNotCorrectFormat('メールアドレス'));
        } else if (this.hasSpecialCharacterInObject(user)) {
          check = false;
          return this.showErrorModal(messageContent.hasSpecialCharacter);
        } else if (!user.username) {
          check = false;
          return this.showErrorModal(messageContent.requireInput('ユーザー名'));
        } else if (!this.hasSymbolCharacterInString(user.username)) {
          check = false;
          return this.showErrorModal(messageContent.requireNotSymbolCharacters('ユーザー名'));
        } else if (user.username.length > 41) {
          check = false;
          return this.showErrorModal(messageContent.requireUnderMaximumNumberOfCharacters('ユーザー名', 41));
        } else if (user.departmentInfo !== '' && !this.hasSymbolCharacterInString(user.departmentInfo)) {
          check = false;
          return this.showErrorModal(messageContent.requireNotSymbolCharacters('部署名'));
        }
        // Length check for メールアドレス, 部署
        let lengthCheck = this.emailLengthCheck(user.userID);
        if (!lengthCheck.status) {
          check = false;
          return this.showErrorModal(lengthCheck.message);
        }
        lengthCheck = this.departmentNameLengthCheck(user.departmentInfo);
        if (!lengthCheck.status) {
          check = false;
          return this.showErrorModal(lengthCheck.message);
        }
        // Underbar check for username
        const underbarCheck = this.fullnameUnderbarCheck(user.username, '名前');
        if (!underbarCheck.status) {
          check = false;
          return this.showErrorModal(underbarCheck.message);
        }
        // Only space check
        let onlySpaceChk = this.onlySpaceCheck(user.username, '名前');
        if (!onlySpaceChk.status) {
          check = false;
          return this.showErrorModal(onlySpaceChk.message);
        }
        onlySpaceChk = this.onlySpaceCheck(user.departmentInfo, '部署');
        if (!onlySpaceChk.status) {
          check = false;
          return this.showErrorModal(onlySpaceChk.message);
        }
        // Duplicate check
        let duplicateCount = -1;
        for (const urs of this.userList) {
          if (urs.userID === user.userID) duplicateCount++;
        }
        if (duplicateCount > 0) {
          check = false;
          return this.showErrorModal(`${user.userID}が重複しています。`);
        }
        return '';
      });
      if (!check) return '';
      this.confirmUserInvitationDialogVisible = true;
      if (utils.chkTrialCompanyID(this.selectedCompanyID)) {
        this.addUserInvitationConfirmationMessage = messageContent.notifyUserAddTrial();
      } else {
        this.addUserInvitationConfirmationMessage = messageContent.notifyUserAdd();
      }

      return '';
    },
    handleConfirmUserInvitation() {
      this.confirmUserInvitationDialogVisible = false;
      const data = this.buildPayloadData();
      this.handleUserInvitationAdd(data);
    },
    handleCancelUserInvitation() {
      this.confirmUserInvitationDialogVisible = false;
    },
    buildPayloadData() {
      return {
        mode: this.userInvitationMode,
        data: this.userInvitationMode === 'list' ? this.userList : this.uploadFile,
      };
    },
    handleUserInvitationAdd(data) {
      const formDataTmp = {
        companyID: this.selectedCompanyID,
        userList: this.userList,
        vdxGroup: this.vdxGroup,
      };
      this.flagSaveButtonEnable = false; //#1892
      this.postRequest('/idmgmt/create', formDataTmp)
        .then(e => {
          this.vdxGroup = e.status === 'vdxGroup';
          if (e.status === 'validationError') {
            this.showErrorModal(e.msg);
          } else if (e.status === statusConst.EXCEED_MAX_USER) {
            this.showErrorModal(messageContent.maxUser(this.maxUser));
          } else if (e.status === statusConst.EXCEED_TRIAL_MAX_USER) {
            this.showErrorModal(messageContent.requireTrialUserAdd(this.maxUser));
          } else if (e.status === 'success') {
            this.showInfoModal(messageContent.userAdded);
          } else if (e.status === 'userExist') {
            this.showErrorModal(this.existItem(e.data.userID));
          } else if (e.status === 'contractCancelled') {
            this.showErrorModal(messageContent.canNotAddUserDueToContractCanceled);
          } else if (e.status === 'contractReview') {
            this.showErrorModal(messageContent.alertNowApplying2());
          } else if (this.vdxGroup) {
            this.vdxGroupModalVisible = true;
          } else {
            this.showErrorModal(messageContent.requireTry('追加'));
          }
          this.flagSaveButtonEnable = true; //#1892
          this.calculateUserAddLimit(); // 追加可能のユーザー数を再計算
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('追加'));
          this.flagSaveButtonEnable = true; //#1892
        });
      return '';
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、ユーザ管理画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/idmgmt', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push('/idmgmt');
      }
    },
    reachLimit(val) {
      if (val) {
        const item = this.isTrial ? `トライアル時は${this.maxUser}ID` : `${this.maxUser}ID`;
        this.showErrorModal(messageContent.reachUserCountLimit(item));
      }
    },
    checkSoStatus: async function () {
      return await this.postRequest('/contract/checksostatus', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            this.soStatusFlag = true;
            this.showErrorModal(messageContent.alertNowApplying2());
            return false;
          }
          this.soStatusFlag = false;
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約変更の申請'));
        });
    },
  },
};
</script>
